import PhotoAlbum from '@/pages/hdd-pages/PhotoAlbum';
import PhotoAlbumDetail from '@/pages/hdd-pages/PhotoDetail';
import PanoramaDetail from '@/pages/hdd-pages/panoramaDetail';
import PanoramaEdit from '@/pages/hdd-pages/PanoramaEdit';
import PanoramaShare from '&/pages/hdd-pages/panoramaShare';
import VirtualHouseCerate from '@/pages/hdd-pages/virtualHouseCreate';
import RenderParams from '@/pages/hdd-pages/renderParams';
import RenderParamsMore from '@/pages/hdd-pages/renderParamsMore';
import Lighting from '@/pages/hdd-pages/lighting';
import RenderingCouponsModal from '@/pages/hdd-pages/renderingCouponsModal';
import BuyRenderingCouponsModal from '@/pages/hdd-pages/buyRenderingCouponsModal';
import BugSuccessModal from '@/pages/hdd-pages/bugSuccessModal';
import MyRenderingCouponsModal from '@/pages/hdd-pages/myRenderingCouponsModal';
import BuyMemberModal from '@/pages/hdd-pages/buyMemberModal';
import ConsultQRCodeModal from '@/pages/hdd-pages/consultQRCodeModal';
import GiveRenderingCoupons from '@/pages/hdd-pages/giveRenderingCoupons';
import DrawingCommentModal from '@/pages/hdd-pages/drawingCommentModal';
import DrawingCommentList from '@/pages/hdd-pages/drawingCommentList';
import CommentListDateRangeModal from '@/pages/hdd-pages/commentListDateRangeModal';
import CeilingComponentManage from '@/pages/hdd-pages/ceilingComponentManage';
import UploadComponentModal from '@/pages/hdd-pages/ceilingComponentManage/uploadModal';
import QuantityTokeOff from '@/pages/hdd-pages/quantityTokeOff/index';
import CustomPublic from '@/pages/hdd-pages/ceilingComponentManage/customPublic';

const HDD_ROUTE_LIST = [
    { path: '/hdd/photoAlbum', component: PhotoAlbum }, //图册
    { path: '/hdd/photoAlbumDetail', component: PhotoAlbumDetail }, //普通图 大图预览
    { path: '/hdd/panoramaDetail', component: PanoramaDetail }, //全景图预览
    { path: '/hdd/panoramaEdit', component: PanoramaEdit }, //全景图全屋漫游编辑
    { path: '/hdd/panoramaShare', component: PanoramaShare }, //全景图全屋漫游分享
    { path: '/hdd/virtualHouseCerate', component: VirtualHouseCerate }, //虚拟户型创建
    { path: '/hdd/virtualHouseEdit', component: VirtualHouseCerate }, //虚拟户型编辑
    { path: '/hdd/renderParams', component: RenderParams }, //渲染参数
    { path: '/hdd/renderParamsMore', component: RenderParamsMore }, //渲染参数更多
    { path: '/hdd/lighting', component: Lighting }, //布光面板
    { path: '/hdd/renderingCouponsList', component: RenderingCouponsModal }, //渲染券列表
    { path: '/hdd/buyRenderingCoupons', component: BuyRenderingCouponsModal }, //购买渲染券
    { path: '/hdd/buySuccessModal', component: BugSuccessModal }, //购买成功
    {
        path: '/hdd/myRenderingCouponsModal', // 我的渲染券
        component: MyRenderingCouponsModal,
    },
    { path: '/hdd/buyMemberModal', component: BuyMemberModal }, // hdd开通会员
    { path: '/hdd/consultQRCodeModal', component: ConsultQRCodeModal }, //咨询二维码
    { path: '/hdd/giveRenderingCoupons', component: GiveRenderingCoupons }, //赠送渲染券
    { path: '/hdd/drawingCommentModal', component: DrawingCommentModal },
    { path: '/hdd/drawingCommentList', component: DrawingCommentList },
    {
        path: '/hdd/commentListDateRangeModal',
        component: CommentListDateRangeModal,
    },
    {
        path: '/hdd/ceilingComponentManage', // 吊顶部件管理
        component: CeilingComponentManage,
    },
    {
        path: '/hdd/uploadComponentModal', // 吊顶部件上传
        component: UploadComponentModal,
    },
    {
        path: '/hdd/quantityTokeOff', // 算量报价
        component: QuantityTokeOff,
    },
    {
        path: '/hdd/customPublic', // 全屋定制公库管理页面
        component: CustomPublic,
    },
];
export default HDD_ROUTE_LIST;
